<template>
  <div class="flex items-center gap-3 px-5 pt-2 pb-1">
    <!-- Step indicators -->
    <div class="flex-1 flex items-center gap-1.5">
      <div v-for="n in 4" :key="n" class="flex-1 h-[3px] rounded-full bar-track relative overflow-hidden">
        <div class="absolute inset-y-0 left-0 rounded-full bar-gradient transition-[width] duration-700 ease-out"
          :style="{ width: progress >= n && mounted ? '100%' : '0%' }"></div>
      </div>
    </div>
    <!-- Label -->
    <Transition name="label" mode="out-in">
      <p :key="label" class="text-[11px] font-semibold tracking-wide bar-label whitespace-nowrap">
        {{ label }}
      </p>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = defineProps<{
  progress: 1 | 2 | 3 | 4;
}>();

const mounted = ref(false);
onMounted(() => {
  requestAnimationFrame(() => { mounted.value = true; });
});

const label = computed(() => {
  return props.progress <= 2
    ? t('connection_stepper.center')
    : t('connection_stepper.user');
});
</script>

<style scoped>
/* Light mode */
.bar-track {
  background: rgba(0, 0, 0, 0.06);
}
.bar-gradient {
  background: linear-gradient(90deg, #06C8FF, #009FE3);
}
.bar-label {
  color: #009FE3;
}

/* Label transition */
.label-enter-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.label-leave-active {
  transition: opacity 0.15s ease, transform 0.15s ease;
}
.label-enter-from {
  opacity: 0;
  transform: translateX(6px);
}
.label-leave-to {
  opacity: 0;
  transform: translateX(-6px);
}

/* Dark mode */
:is(.dark *).bar-track {
  background: rgba(255, 255, 255, 0.08);
}
:is(.dark *).bar-label {
  color: #06C8FF;
}
</style>
